/**
 * @module app.cd
 */

import { autoinject } from 'aurelia-framework';
import { RouteConfig, NavigationInstruction } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { apiCall } from 'app/shared/lib/api/api';
import { AuthService } from 'app/cd/services/auth-service';
import * as CD from 'app/cd/models/essette-api';


@autoinject()
export class AuthSummaryPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected authId: string | null = null;
    protected auth: CD.Auth | null = null;
    protected readonly: boolean = true;


    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly service: AuthService,
        private readonly i18n: I18N,
        ...rest: any[]) {

        super(...rest);
    }

    protected async canActivate(params: any, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<boolean> {
        await this.accountContext.load();
        return this.accountContext.hasRouteAccess('cd.auth.summary');
    }

    protected async activate(params: { authId: string }, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<void> {
        if(!params?.authId) {
            throw new Error('Missing required parameters: authId');
        }

        this.authId = params.authId;
        await this.reload();

        if(this.auth && routeConfig.navModel) {
            const title = this.i18n.tr('cd:routes.auth.summary.$title', { number: this.auth?.number });
            routeConfig.navModel.setTitle(title);
        }
    }


    //protected created(owningView: View, myView: View): void { }
    //protected bind(bindingContext: Object, overrideContext: Object): void { }
    //protected attached(): void { }
    //protected deactivate(): void { }
    //protected detached(): void { }
    //protected unbind(): void { }



    ////****************** Events ***************************************************////
    public async reload(): Promise<void> {
        if(this.authId) {
            await this.loadAuth(this.authId);
        }
    }


    ////****************** Functions ************************************************////



    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadAuth(authId: string): Promise<void> {
        if(!authId) return;

        const includes: string[] = [];

        try {
            this.state.beginLoad();

            const response = await this.service.loadAuth(authId, includes);
            this.auth = response.results[0];
        }
        catch(error) {
            throw error;
        }
        finally {
            this.state.endLoad();
        }
    }

}
